var map = {
	"./calendar.svg": "./resources/images/views-upsell/calendar.svg",
	"./dashboard.svg": "./resources/images/views-upsell/dashboard.svg",
	"./map.svg": "./resources/images/views-upsell/map.svg",
	"./table.svg": "./resources/images/views-upsell/table.svg",
	"./timeline.svg": "./resources/images/views-upsell/timeline.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/images/views-upsell sync recursive ^\\.\\/.*\\.svg$";